import  { useEffect, useState } from "react";
import VerticalTabs from "../../../../genericComponents/verticalTabs/VerticalTabs";
import MinimalContactCard from "./MinimalContactCard";
import NurtureCampaignEmailReachOut from "./NurtureCampaignEmailReachOut";
import {
  getAnalyticsByCampId,
  getContactWiseTemplates,
  previewCampaignDetails,
} from "../../../../../../services/iqApiV2";
import { formatDateWithTime } from "../../../../../../utilities/dateUtils";

const NurtureCampaignEmailReachOutV2 = ({
  currentCampDetails = {},
  stepDispatch=()=>{},
  stepId,
  setCurrentStepIndex=()=>{},
  emails,
  setEmails,
  sideCardCloseFunc = () => {},
  skipReview = false,
}) => {
   console.log("currentCampDetails",currentCampDetails?.startDate)
  //  const [allEmails, setAllEmails] = useState([]);
  //  const [dataLoading,setDataLoading]=useState(false);
  const [isCampaignActive, setIsCampaignActive] = useState(false);
  useEffect(() => {
    if (!currentCampDetails?.campaignId) return;

    let intervalId;
    let timeoutId;

    const fetchData = async () => {
      try {
        const response = await getContactWiseTemplates(
          currentCampDetails?.campaignId
        );

        //  if(response?.length<0)setDataLoading(true);
        //  if(response?.length>0)setDataLoading(false);

        console.log("response", response);

        const isComplete =
          response?.length > 0
            ? response?.every(
                (item) =>
                  Array.isArray(item.templates) &&
                  item.templates.length >= 1 &&
                  item.templates.every(
                    (tpl) =>
                      tpl?.subject !== "Generating..." &&
                      tpl?.bodycontent !== "Generating..."
                  )
              )
            : false;
        setEmails(response);

        if (isComplete) {
          //  setEnableNextBtn(true);
          console.log("✅ Condition met, stopping poll");
          clearInterval(intervalId);
          clearTimeout(timeoutId); // stop timeout as well
          return;
        }

        console.log("⏳ Condition not met yet, continuing poll");
      } catch (err) {
        console.error("❌ Fetch error:", err);
      }
    };

    async function getPreviewDetails() {
      const MAX_RETRIES = 240; // Retry every 5s for 20 minutes → (20 * 60) / 5 = 240
      const RETRY_DELAY = 5000;

      let retryCount = 0;

      async function attemptPreviewFetch() {
        try {
          const resp = await previewCampaignDetails(currentCampDetails?.campaignId);
          const isCampaignActive = resp?.campaign?.[0]?.active_status;
          setIsCampaignActive(isCampaignActive);

          if (isCampaignActive) {
            const analyticsResp = await getAnalyticsByCampId(currentCampDetails?.campaignId);
            const foundContactDetail = analyticsResp?.data?.map((f) => f?.queue_items).flat();
            const savedTemplates = resp?.contactwise_templates?.[0];

            const modifiedSaved = savedTemplates.map((eachItem) => {
              const modifiedTemplatesPerContact = eachItem?.templates?.map((ei) => {
                const foundContact = foundContactDetail.find(
                  (fi) => fi?.template_id?.["$oid"] == ei?._id
                );

                if (foundContact?.sent) {
                  ei.sent = foundContact?.sent;
                  ei.isReplied = foundContact?.is_replied;
                  ei.isBounced = foundContact?.is_bounced;
                  ei.isOpened = foundContact?.is_opened;
                  ei.replies = foundContact?.sent_emails?.[0]?.replies?.map((rep) => ({
                    subject: rep?.subject,
                    bodycontent: rep?.body?.content,
                    id: rep?.id,
                    recievedDate: formatDateWithTime(rep?.receivedDateTime, { use12Hour: true }),
                    sender: rep?.sender?.emailAddress?.name
                  }));
                }

                return ei;
              });

              return { ...eachItem, templates: modifiedTemplatesPerContact };
            });

            setEmails(modifiedSaved);
            console.log("modifiedSaved", modifiedSaved);
          } else {
            fetchData();
            intervalId = setInterval(fetchData, RETRY_DELAY);
          }

        } catch (error) {
          retryCount++;
          console.warn(`Retry ${retryCount}/${MAX_RETRIES}: previewCampaignDetails failed`);

          if (retryCount < MAX_RETRIES) {
            setTimeout(attemptPreviewFetch, RETRY_DELAY);
          } else {
            console.error("Max retry limit reached. Could not fetch preview campaign details.");
          }
        }
      }

      await attemptPreviewFetch();
    }


    // initial call
  

    getPreviewDetails();



    // stop polling after 5 minutes max
    timeoutId = setTimeout(() => {
      console.warn("⏱️ Max 5 min reached, stopping poll");
      clearInterval(intervalId);
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [currentCampDetails?.campaignId,currentCampDetails?.startDate]);

  return (
    <div
      style={{
        marginTop: "1rem",
        display: "flex",
        justifyContent: "flex-start",
        maxHeight: "68vh",
        borderRadius: "0.5rem",
        border: "solid 0.1rem rgba(150, 150, 150, 0.25)",
        overflow: "hidden",
      }}
    >
    
        <VerticalTabs
          tabs={emails}
          TabComp={MinimalContactCard}
          TabContent={NurtureCampaignEmailReachOut}
          compProps={{
            currentCampDetails,
            stepDispatch,
            stepId,
            setCurrentStepIndex,
            emails,
            setEmails,
            skipReview: skipReview,
            sideCardCloseFunc: sideCardCloseFunc,
            isCampaignActive: isCampaignActive,
          }}
        />
      
    </div>
  );
};

export default NurtureCampaignEmailReachOutV2;
